import { FIELD_NAMES } from '../../components/pricing-drawer/constants';
import { FieldNames } from '../../components/pricing-drawer/types';

type Params = {
  params: URLSearchParams;
};

type RefinePriceQueryValues = Partial<Record<FieldNames, string>>;

const refinePriceFields = Object.values(FIELD_NAMES) as FieldNames[];

const getRefinePriceQueryValues = ({ params }: Params): RefinePriceQueryValues => {
  const updatedFields: RefinePriceQueryValues = {};

  refinePriceFields.forEach((fieldName) => {
    const value = params.get(fieldName);
    if (value !== null) {
      updatedFields[fieldName] = value;
    }
  });

  return updatedFields;
};

export default getRefinePriceQueryValues;
